export default {
  path: '/v5/redeem',
  name: 'V5_redeem',
  component: () => import('./RedeemPage.vue'),
};
